import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AiFeatureType, AiFeaturePeriod} from 'nutshell-graphql-types';
import type {
    GetAiFeature as GetAiFeatureQuery,
    GetAiFeature_aiFeature as AiFeature,
    GetAiFeatureVariables,
} from 'nutshell-graphql-types';

import GET_AI_FEATURE from '../queries/get-ai-feature.graphql';

export const useGetAiFeature = (
    type: AiFeatureType,
    period: AiFeaturePeriod,
    skip?: boolean
): {
    aiFeature: AiFeature | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetAiFeatureQuery, GetAiFeatureVariables>(
        GET_AI_FEATURE,
        {
            variables: {
                type,
                period,
            },
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    const aiFeature = data ? data.aiFeature : null;

    return {
        aiFeature,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
